import { atom } from 'jotai'

export type UserStatus = 'A' | 'M' | 'H' | 'C' | 'S' | 'T' | 'W'

const USER_STATUS_KEY = 'fg_user_status'

export const readStoredUserStatus = (): UserStatus | null => {
    try {
        return (localStorage.getItem(USER_STATUS_KEY) as UserStatus) || null
    } catch {
        return null
    }
}

export const persistUserStatus = (status: string): void => {
    try {
        localStorage.setItem(USER_STATUS_KEY, status)
    } catch {
        /* storage unavailable */
    }
}

export const clearUserStatus = (): void => {
    try {
        localStorage.removeItem(USER_STATUS_KEY)
    } catch {
        /* storage unavailable */
    }
}

export const userStatusAtom = atom<UserStatus | null>(null)
